import FileCopyIcon from "@material-ui/icons/FileCopy";
import { get } from "lodash";
import React, { useState } from "react";
import { Button, useDataProvider } from "react-admin";
import { useHistory } from "react-router-dom";

const CloneButton = ({
	basePath = "",
	label = "ra.action.clone",
	record,
	...rest
}) => {
	const dataProvider = useDataProvider();
	const [loading, setLoading] = useState(false);
	const history = useHistory(); // Note: history is mutable. This prevents render loops in useCallback.

	const clone = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setLoading(true);
		dataProvider.getOne("bookmakers", { id: record.id }).then((response) => {
			setLoading(false);
			const data = get(response, "data", {});
			const {
				id,
				created,
				modified,
				logo,
				logo_path,
				logo_name,
				logo_size,
				sync_channel_config_object,
				sync_config_customers_object,
				excerpt,
				...old
			} = data;

			const state = {
				record: {
					...old,
					code: `${old.code}-copy`,
					name: `${old.name} (copy)`,
				},
			};
			history.push({
				pathname: "/bookmakers/create",
				state: { _scrollToTop: true, ...state },
			});
		});
	};

	return (
		<Button label={label} color="secondary" onClick={clone} disabled={loading}>
			<FileCopyIcon />
		</Button>
	);
};

export default CloneButton;
